import { OperationalParametersWidgetWrapper } from '../../operational-parameters-widget/OperationalParametersWidget';
import type { OperationalParametersWidgetEntity } from '../../operational-parameters-widget/OperationalParametersWidget.entity';

import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';

export function renderOperationalParametersWidget(
  widget: OperationalParametersWidgetEntity,
  options: TWidgetRendererOptions,
): TRenderWidget {
  return () => <OperationalParametersWidgetWrapper entity={widget} options={options} />;
}
